import { getSessionVar } from '../../../../lib/helpers';
import { RV_TOOLS_UPLOAD_SIZE_LIMIT } from '../../../../constants/discovery';

export const getMaxCompressedFileSizeMB = () =>
    getSessionVar('discovery_multipart_compressed_max_file_size_in_megabytes') ||
    RV_TOOLS_UPLOAD_SIZE_LIMIT.compressedMB;

export const getMaxUncompressedFileSizeMB = () =>
    getSessionVar('discovery_multipart_uncompressed_max_file_size_in_megabytes') ||
    RV_TOOLS_UPLOAD_SIZE_LIMIT.uncompressedMB;
